import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component';

import Header from './Header';
import Footer from './Footer';
import ConnectButton from './metamask/button';
import { OwnSodabitsGrid, RandomSodabitGrid, useOwnSodabits } from './grid';


function PFPApp() {
  const [currentImage, setCurrentImage] = useState();
  const ownSodabits = useOwnSodabits();
  const haveSodabits = !!ownSodabits.length;
  const numberRef = useRef();

  const onSubmit = useCallback((event) => {
    event?.preventDefault();
    const selected = numberRef.current.value;
    if (selected) {
      const url = `/cropped/${selected}.png`;
      setCurrentImage(url);
    }
  }, []);

  const chooseRandom = useCallback(() => {
    const selected = Math.ceil(1000 * Math.random())

    numberRef.current.value = selected;
    onSubmit();
  }, [ onSubmit ]);

  const onGridClick = useCallback((selected) => {
    numberRef.current.value = selected;
    onSubmit();
    window.location = "#top";
  }, [ onSubmit ]);

  return (<>
    <div className="container py-3">
      <Header />
      <main>

      <div className="row w-100 justify-content-center">
        <div className="col-md-7 align-self-center p-4">
          <h1 className="font-weight-bold">Sodabit Profile Pic Generator</h1>
          <div className="h5 py-2">
            Use the tool below to create a profile picture for your social media.
            If you need to find a sodabit # <a target="_blank" href="https://opensea.io/collection/sodabits">View Our Collection</a>
          </div>

          <form className="py-3" onSubmit={onSubmit}>
            <div className="form-group">
              <label> Enter Sodabit #</label>
              <input ref={numberRef} type="number" className="form-control" name="txtPFP" placeholder="#1-1000" aria-describedby="sodabitHelp" min="1" max="1000" required="" />
              <small id="sodabitHelp" className="form-text text-muted">Enter a Sodabit number from our collection. On mobile phone you can tap and hold "Save Image"</small>
            </div>

            <br />

            <div className="row align-items-center justify-content-between">
              <div className="col col-sm-7 d-inline-flex actions-button-container">
                <button type="submit" className="btn btn-primary btn-md py-2">Show Profile Pic</button>
                <button onClick={chooseRandom} className="btn btn-lucky btn-sm btn-random-pfp mx-4 py-2"> I'm feeling lucky </button>
              </div>

              <div className="w-100 d-none col-breaker"> </div>

              <ConnectButton className="col-sm-5 align-self-end " />
            </div>

              <div className="text-center" id="top">
            { currentImage &&
                <a download title="Sodabit Download" href={currentImage}>
                    <img src={currentImage} className="p-4 img-fluid w-50" />
                </a>
            }
              </div>
          </form>
        </div>
      </div>

    { haveSodabits &&
      <div className="row w-100 justify-content-center">
        <div className="col-md-7 align-self-center p-4">
          <h2 className="font-weight-bold pb-4">My Sodabits</h2>
          <OwnSodabitsGrid onClick={onGridClick}/>
        </div>
      </div>
    }

      <div className="row w-100 justify-content-center">
        <div className="col-md-7 align-self-center p-4">
          <h2 className="font-weight-bold pb-4">Or Select any random Sodabit</h2>
          <RandomSodabitGrid onClick={onGridClick}/>
        </div>
      </div>

      </main>
    </div>

    <Footer />
  </>);
}

export default PFPApp;
